import { handleAction } from '@mendeley-internal/lib-js-redux-actions';
import { saveToLibrary } from '../actions/library';

export default handleAction(saveToLibrary, {
  first(state, { meta: { doc } }) {
    return {
      ...state,
      [doc.id]: {
        pending: true
      }
    };
  },
  next(state, { meta: { doc } }) {
    return {
      ...state,
      [doc.id]: {
        exists: true,
        pending: false
      }
    };
  },
  throw(state, { meta: { doc }, payload: { response } }) {
    return {
      ...state,
      [doc.id]: {
        exists: false,
        error: response.status,
        pending: false
      }
    };
  }
}, {});



// WEBPACK FOOTER //
// ./src/universal/ui/reducers/library.js